module.exports = __webpack_public_path__ + "static/media/RA-AC0009S_03.b711fd7e.png";